const DEVICE_ID_KEY = "fdp-device-id";

/**
 * A random, anonymous identifier for this browser -- not tied to an
 * email, name, or any personal information, and never sent anywhere
 * except back to our own server alongside a tool-usage count. Exists
 * purely so the free daily usage limit can apply before someone signs
 * in at all, instead of requiring an account just to try a tool once.
 *
 * Generated once and persisted in localStorage; clearing browser data
 * or using a private/incognito window resets it, which resets the daily
 * count too. That's a known, accepted trade-off (see the note in
 * ToolLayout.tsx) -- this is a fair-use nudge, not an anti-abuse wall,
 * and the trust cost of requiring login before every first use outweighs
 * the marginal risk of someone bothering to reset it for a few extra
 * free uses.
 */
export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    // localStorage unavailable (private mode in some browsers, storage
    // disabled entirely) -- fall back to a fresh ID each call. Usage
    // just won't persist across page loads for that visitor, which
    // fails toward "more free uses," not toward blocking a real user.
    return crypto.randomUUID();
  }
}
